import React from "react";
import { Route, Link, Switch } from "react-router-dom";

import Home from "../components/Home.js";
import SubPage from "./SubPage.js";

function Main() {
  return (
    <main>
      <Switch>
        <Route exact path="/">
          <Home></Home>
        </Route>
        <Route path="/:type">
          <SubPage></SubPage>
        </Route>
      </Switch>
    </main>
  );
}

export default Main;
